import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--text-counter"
export default class extends Controller {
  static targets = ["input", "counter", "alertContainer"];
  static values = {
    max: Number,
    errorClass: String,
  };

  connect() {
    this.update();
  }

  update() {
    const text = this.inputTarget.value;
    const length = text
      ? text.length + (text.match(/\r\n|\n|\r/g) || []).length
      : 0;

    this.counterTarget.innerText = length;

    if (!this.alertContainerTarget || !this.maxValue || !this.errorClassValue) {
      return;
    }

    if (length > this.maxValue) {
      this.alertContainerTarget.classList.add(this.errorClassValue);
    } else {
      this.alertContainerTarget.classList.remove(this.errorClassValue);
    }
  }
}
